var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"card",staticClass:"card",attrs:{"target":"_blank"},on:{"mousemove":_vm.move,"mouseleave":_vm.leave,"mouseover":_vm.over}},[_vm._t("default",function(){return [_vm._v(" 无内容 ")]}),(_vm.reflection)?_c('div',{ref:"refl",staticClass:"reflection"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }